/**
 * History hub — my runs (REQ-AIS-121 Plane A / S9).
 */

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';
import { listMyRuns } from '@/services/aiStudioMonitorService';

const AIStudioHistoryHubPage: React.FC = () => {
  const { t } = useLanguage();
  const [runs, setRuns] = useState<Record<string, unknown>[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    listMyRuns({ limit: 50 })
      .then((rows) => {
        if (!cancelled) setRuns(rows);
      })
      .catch(() => {
        if (!cancelled) setRuns([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <main className="flex w-full flex-col gap-4 px-4 py-4 md:px-6 lg:px-8">
      <header>
        <h1 className="text-lg font-semibold text-[var(--color-surface-text)]">
          {t('aiStudio.history.hubTitle')}
        </h1>
        <p className="mt-1 text-base text-[var(--color-surface-text-secondary)]">
          {t('aiStudio.history.hubHint')}
        </p>
      </header>

      {loading && (
        <p className="text-base text-[var(--color-surface-text-secondary)]">
          {t('aiStudio.history.loading')}
        </p>
      )}

      {!loading && runs.length === 0 && (
        <p className="text-base text-[var(--color-surface-text-secondary)]">
          {t('aiStudio.history.hubEmpty')}
        </p>
      )}

      {!loading && runs.length > 0 && (
        <ul className="flex flex-col gap-2">
          {runs.map((run) => {
            const id = String(run['id']);
            return (
              <li
                key={id}
                className="flex flex-wrap items-center justify-between gap-2 rounded border border-[var(--color-border)] px-3 py-2"
              >
                <div>
                  <Link to={`/ai-studio/runs/${id}`} className="text-base text-[var(--color-info)] underline">
                    {String(run['run_name'] ?? id)}
                  </Link>
                  <p className="text-base text-[var(--color-surface-text-secondary)]">
                    {String(run['agent_name'] ?? '')} · v{String(run['version_number'] ?? '')} ·{' '}
                    {String(run['status'] ?? '')}
                  </p>
                </div>
                <span className="text-base text-[var(--color-surface-text-secondary)]">
                  {run['updated_at'] ? new Date(String(run['updated_at'])).toLocaleString() : ''}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </main>
  );
};

export default AIStudioHistoryHubPage;
